import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    subscription: null,
    payment: null,
    material: null,
    program: null
  },
  mutations: {
    setSubscription(state, subscription) {
      state.subscription = subscription
    },
    setPayment(state, payment) {
      state.payment = payment
    },
    setMaterial(state, material) {
      state.material = material
    },
    setProgram(state, program) {
      state.program = program
    }
  },
  actions: {
    setSubscriptionInfo({ commit }, { subscription, payment, material, program }) {
      commit('setSubscription', subscription)
      commit('setPayment', payment)
      commit('setMaterial', material)
      commit('setProgram', program)
    }
  }
})